import { Component, OnInit, Input } from "@angular/core";
import { CasingType } from "../models/casing-plan.model";

@Component({
    selector: "casing-data-pages",
    templateUrl: "./casing-data-pages.component.html",
    styleUrls: ["./casing-data-pages.component.scss"],
    standalone: false
})
export class CasingDataPagesComponent implements OnInit {

    @Input() casingType: CasingType;

    types = CasingType;

    constructor() { }

    ngOnInit() {
    }

}
